import { render, staticRenderFns } from "./RecordChunk.vue?vue&type=template&id=4e565cba&scoped=true&"
import script from "./RecordChunk.vue?vue&type=script&lang=js&"
export * from "./RecordChunk.vue?vue&type=script&lang=js&"
import style0 from "./RecordChunk.vue?vue&type=style&index=0&id=4e565cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e565cba",
  null
  
)

export default component.exports